import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Input, Button, Dropdown, DropdownToggle, DropdownMenu, FormGroup, Label } from 'reactstrap';
import DatePicker from 'react-datepicker';
import { FaCalendarAlt } from 'react-icons/fa';
import CreateNewProjectService from '../../../../../Service/DashboardServices/ProjectsDashboard/CreateNewProjectService';
import { connect } from 'react-redux';
import NewProjectProductList from '../Scenes/SidebarComponents/NewProjectProductList';
import FetchCMProductDataService from '../../../../../Service/DashboardServices/ContentManagementServices/FetchCMProductDataService';
import NewTaskIcon from '../../../../../designUtils/OpsDashboard/MyTasks/NewTaskIcon.svg';
import CustomModal from '../../../../Components/Modals/CustomModal';
import ReactQuill from 'react-quill';
import { Editor, SetInnerHtmlWithClassReplacement } from "../../../../../Utils/Constants";

const BRAND_WORKFLOW_IDS = [7, 8, 9];

function CreateNewProjectDetails(props) {

    const [dueDate, setDueDate] = useState(null);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [selectedStore, setSelectedStore] = useState()
    const [selectedAccount, setSelectedAccount] = useState()
    const [selectedProjectOwner, setSelectedProjectOwner] = useState()
    const [selectedGraphicDesigner, setSelectedGraphicDesigner] = useState([])
    const [selectedAsin, setSelectedAsin] = useState()
    const [asinList, setAsinList] = useState()
    const [projectName, setProjectName] = useState('');
  const [productList,setProductList]=useState()
  const [addProductsPopup, setAddProductsPopup] = useState(false)
  const [selectedWorkFlow, setSelectedWorkFlow] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState()
  const [errors, setErrors] = useState({});
  const [selectedStoreName,setSelectedStoreName]=useState()
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const[loading,setLoading]=useState(false)
  const [duplicateProjects, setDuplicateProjects] = useState(null);
  const [text, setText] = useState('')
  const [workflowDropdownOpen, setWorkflowDropdownOpen] = useState(false);
  const [designerDropdownOpen, setDesignerDropdownOpen] = useState(false);

  const toggleWorkflowDropdown = () => setWorkflowDropdownOpen(prevState => !prevState);
  const toggleDesignerDropdown = () => setDesignerDropdownOpen(prevState => !prevState);

  const isBrandWorkflowSelected = function (workflows) {
    return (workflows || []).some(function (wfId) {
      return BRAND_WORKFLOW_IDS.indexOf(Number(wfId)) !== -1;
    });
  };

  const getProductDisplayName = function (product) {
    if (!product) return '';
    return (product.productTitle || product.name || '').trim();
  };

  const truncateString = function (str, maxLength) {
    if (!str) return '';
    if (str.length <= maxLength) return str.trim();
    return str.slice(0, maxLength).trim();
  };

  const resolveParentAsin = function (product) {
    if (!product) return '';
    if (product.isParentProduct) return product.asin;
    return product.parentProduct || product.asin || '';
  };

  const resolveProductByAsin = function (asin, products, fallbackProducts) {
    return (products || []).find(function (p) { return p.asin === asin; })
      || (fallbackProducts || []).find(function (p) { return p.asin === asin; })
      || (fallbackProducts || []).find(function (p) { return p.parentProduct === asin; })
      || null;
  };

  // Naming convention:
  // 1 ASIN: Store(20) - Workflow(no Creation) - ASIN - Product(15)
  // Multiple ASINs same parent: Store(20) - Workflow - Parent ASIN - Parent Product(15)
  // Multiple ASINs different parents: Store(20) - Workflow - ParentASINs(comma) - First Parent Product(15)
  const buildAutoProjectName = function (storeId, workflows, asins, products) {
    const store = (props.storeList || []).find(function (s) {
      return String(s.id) === String(storeId);
    });
    const storeName = truncateString(store && store.name ? store.name.trim() : '', 20);
    if (!storeName) return '';

    const workflowNames = (props.workFlowList || [])
      .filter(function (wf) {
        return (workflows || []).some(function (id) {
          return Number(id) === Number(wf.id);
        });
      })
      .map(function (wf) {
        return (wf.name || '').replace(/\bCreation\b/gi, '').replace(/\s+/g, ' ').trim();
      })
      .filter(Boolean)
      .join(', ');

    if (isBrandWorkflowSelected(workflows)) {
      return workflowNames ? (storeName + ' - ' + workflowNames) : storeName;
    }

    const asinArr = (Array.isArray(asins) ? asins : []).filter(Boolean);
    let finalAsinStr = '';
    let finalProductName = '';

    if (asinArr.length > 0) {
      const selectedProducts = asinArr
        .map(function (asin) {
          return (products || []).find(function (p) { return p.asin === asin; });
        })
        .filter(Boolean);

      if (asinArr.length === 1) {
        finalAsinStr = asinArr[0];
        finalProductName = truncateString(
          getProductDisplayName(selectedProducts[0]),
          15
        );
      } else {
        const parentAsins = selectedProducts
          .map(resolveParentAsin)
          .filter(Boolean);
        const uniqueParents = Array.from(new Set(parentAsins));

        if (uniqueParents.length === 1) {
          finalAsinStr = uniqueParents[0];
          const parentProd = resolveProductByAsin(
            uniqueParents[0],
            products,
            selectedProducts
          );
          finalProductName = truncateString(getProductDisplayName(parentProd), 15);
        } else if (uniqueParents.length > 1) {
          finalAsinStr = uniqueParents.join(',');
          const firstParentProd = resolveProductByAsin(
            uniqueParents[0],
            products,
            selectedProducts
          );
          finalProductName = truncateString(
            getProductDisplayName(firstParentProd),
            15
          );
        } else {
          finalAsinStr = asinArr.join(',');
          finalProductName = truncateString(
            getProductDisplayName(selectedProducts[0]),
            15
          );
        }
      }
    }

    const parts = [storeName];
    if (workflowNames) parts.push(workflowNames);
    if (finalAsinStr) parts.push(finalAsinStr);
    if (finalProductName) parts.push(finalProductName);

    return parts.join(' - ');
  };

  const handleWorkFlowCheckboxChange = (id) => {
    let updatedWorkflows = [...selectedWorkFlow];
    if (updatedWorkflows.includes(id)) {
        updatedWorkflows = updatedWorkflows.filter(item => item !== id);
    } else {
        updatedWorkflows.push(id);
    }
    setSelectedWorkFlow(updatedWorkflows);
    // Workflows 7/8/9 do not use ASINs — hide Add ASINs and clear any selected list
    if (isBrandWorkflowSelected(updatedWorkflows)) {
      setAsinList([]);
      setSelectedAsin();
    }
    if (updatedWorkflows.length > 0) {
        setErrors(prev => ({ ...prev, selectedWorkFlow: null }));
    }
    };

    const getSelectedWorkflowNames = () => {
        if (selectedWorkFlow.length === 0) return "Select WorkFlows";
        return props.workFlowList
            .filter(wf => selectedWorkFlow.includes(wf.id.toString()) || selectedWorkFlow.includes(wf.id))
            .map(wf => wf.name)
            .join(", ");
    };

  const hideAddAsinsButton = isBrandWorkflowSelected(selectedWorkFlow);

  // Live project name: updates instantly when Account / Workflow / ASIN changes
  useEffect(function () {
    const autoName = buildAutoProjectName(
      selectedStore,
      selectedWorkFlow,
      asinList,
      productList
    );
    setProjectName(autoName);
    if (autoName) {
      setErrors(function (prev) {
        return Object.assign({}, prev, { projectName: null });
      });
    }
  }, [selectedStore, selectedWorkFlow, asinList, productList, props.storeList, props.workFlowList]);


  const validateFields = () => {
    const newErrors = {};
  
    if (!projectName || projectName.trim() === '') newErrors.projectName = 'Project Name is required';
    // if (!selectedAccount) newErrors.selectedAccount = 'Account Name is required';
    if (!selectedStore) newErrors.selectedStore = 'Store Name is required';
    if (!selectedWorkFlow) newErrors.selectedWorkFlow = 'WorkFlow is required';
    // if (!selectedBrand) newErrors.selectedBrand = 'Brand is required';
    if (!selectedProjectOwner) newErrors.selectedProjectOwner = 'Project Owner is required';
    // if (!selectedGraphicDesigner) newErrors.selectedGraphicDesigner = 'Graphic Designer is required';
    // if (!startDate) newErrors.startDate = 'Start Date is required';
    // if (!dueDate) newErrors.dueDate = 'Due Date is required';
  
    setErrors(newErrors);
  
    return Object.keys(newErrors).length === 0;
  };

  const handleQuillChange = (value) => {
    setText(value);
};
  
const handleStoreChange = (e) => {
  const selectedStoreId = e.target.value;
  const selectedStoreDetail = props.storeList.find(
      store => store.id.toString() === selectedStoreId
  );

  setSelectedStoreName(selectedStoreDetail ? selectedStoreDetail.name : '');
  setSelectedStore(selectedStoreId);
  setSelectedBrand('');

  if (selectedStoreId) {
      setErrors(prev => ({ ...prev, selectedStore: null }));
  }
};
    
    const handleAccountChange = (e) => {
        const value = e.target.value;
        setSelectedAccount(value);
        setSelectedStore('');
        setSelectedStoreName('');
        setSelectedBrand('');
        if (value) setErrors(prev => ({ ...prev, selectedAccount: null }));
      };
    const handleProjectOwnerChange = (e) => {
        const value = e.target.value;
        setSelectedProjectOwner(value);
        if (value) setErrors(prev => ({ ...prev, selectedProjectOwner: null }));
    };
    const handleGraphicDesignerCheckboxChange = (id) => {
        const designerId = Number(id);
        let updated = [...(selectedGraphicDesigner || [])];
        if (updated.map(Number).includes(designerId)) {
            updated = updated.filter(item => Number(item) !== designerId);
        } else {
            updated.push(designerId);
        }
        setSelectedGraphicDesigner(updated);
        if (updated.length > 0) {
            setErrors(prev => ({ ...prev, selectedGraphicDesigner: null }));
        }
    };

    const getSelectedDesignerNames = () => {
        if (!selectedGraphicDesigner || selectedGraphicDesigner.length === 0) {
            return 'Select Graphic Designer';
        }
        return (props.graphicDesignerList || [])
            .filter(d => selectedGraphicDesigner.map(Number).includes(Number(d.id)))
            .map(d => (d.name || '').replace(/\s*Working\(\d+\)\s*$/, ''))
            .join(', ');
    };
    // const handleWorkFlowChange = (e) => {
    //     const value = e.target.value;
    //     setSelectedWorkFlow(value);
    //     if (value) setErrors(prev => ({ ...prev, selectedWorkFlow: null }));
    // };
    const handleBrandChange = (e) => {
        const value = e.target.value;
        setSelectedBrand(value);
        if (value) setErrors(prev => ({ ...prev, selectedBrand: null }));
    };
    const handleStartDateChange = (date) => {
        setStartDate(date);
      
        if (date) {
          setErrors((prev) => ({ ...prev, startDate: null }));
        }
      };

      const handleDueDateChange = (date) => {
        setDueDate(date);
      
        if (date) {
          setErrors((prev) => ({ ...prev, dueDate: null }));
        }
      };
      
      const formatDateForBackend = (date) => {
        if (!date) return null;
        
        // Format as YYYY-MM-DD to avoid timezone issues
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        
        return `${year}-${month}-${day}`;
    };
  const handleSaveProjectDetails = () => {
    if (!validateFields()) return;
    
    const duplicateProjects = props.projectDetailsList.filter(project =>
        // project.accountId === parseInt(selectedAccount) &&
        project.integerId === parseInt(selectedStore) &&
        project.brandId === parseInt(selectedBrand) &&
        selectedWorkFlow.map(id => parseInt(id)).includes(parseInt(project.workflowsId))
    );

    if (duplicateProjects.length > 0) {
        // Store all duplicate project details
        setDuplicateProjects(duplicateProjects);
        setShowConfirmationPopup(true);
        return;
    }
    
    // If not duplicate, proceed with saving
    saveProject();
};

// Separate function to handle the actual saving
const saveProject = () => {
    let data = {
        // accountId: selectedAccount,
        integerId: selectedStore,
        asin: asinList,
        projectName: projectName,
        dueDate: formatDateForBackend(dueDate),
        startDate: formatDateForBackend(startDate),
        projectOwner: selectedProjectOwner,
        graphicDesigner: selectedGraphicDesigner,
        brand: selectedBrand,
        workflow: selectedWorkFlow,
        description:text
    };
    setLoading(true)
    CreateNewProjectService(props.token, data).then((res) => {
        if (res) {
            console.log(res);
            props.setProjectDetailsList(res.ProjectDetailsList);
            props.setIsCreateModal(false);
            setLoading(false)
        }
    });
};

const handleConfirmationYes = () => {
    setShowConfirmationPopup(false);
    saveProject(); // Proceed with saving
};

const handleConfirmationNo = () => {
    setShowConfirmationPopup(false);
    // Stay on the project create screen - no additional action needed
};


  const handleSelectProduct=()=>{
    let data={
        asinList:'',
        integerID:selectedStore,
        projectId:0,
        fetchAll: true
    }
    FetchCMProductDataService(props.token,data).then((res)=>{
        if(res){
            console.log(res)
            setProductList(res.productsList)
            setAddProductsPopup(true)
        }
    })
  }
  // const filteredStores = props.storeList && props.storeList.filter(
  //   store => selectedAccount && store.account_details === Number(selectedAccount)
  // );
    return (
        <>
            <Col className='mb-4 px-3'>
            {/* {duplicateProjectWarning && (
            <div className="text-danger text-center mb-3" style={{ fontWeight: 'bold' }}>
                {duplicateProjectWarning}
            </div>
            )} */}
                <Row>
                    <Col md={2}>
                        <label>
                            <h6 className='mt-2'>
                                <b>Name : <span style={{ color: 'red' }}>*</span></b>
                            </h6>
                        </label>
                    </Col>
                    <Col md={10}>
                        <Input
                            type="text"
                            value={projectName}
                            onChange={(e) => setProjectName(e.target.value)}
                            id="projectname"
                            name="projectname"
                            placeholder="Auto-generated project name"
                            className="create-new-project-width"
                        />
                        {errors.projectName && <div className="text-danger">{errors.projectName}</div>}
                    </Col>
                </Row>
                {/* <Col md={6}>
                        <label><h6><b>Account Name : <span style={{color: 'red'}}>*</span></b></h6></label>
                        <select
                            className="form-control create-new-project-width"
                            onChange={handleAccountChange}
                            value={selectedAccount}
                        >
                            <option value="">Select Account Name</option>
                            {props.accountList && props.accountList.map((account) => (
                                <option key={account.id} value={account.id}>
                                    {account.name}
                                </option>
                            ))}
                        </select>
                        {errors.selectedAccount && <div className="text-danger">{errors.selectedAccount}</div>}
                    </Col> */}

                <Row>
                    <Col md={6} className='mt-3'>
                        <label><h6><b>Store Name : <span style={{ color: 'red' }}>*</span></b></h6></label>
                        <select
                            className="form-control create-new-project-width"
                            onChange={handleStoreChange}
                            value={selectedStore}
                        >
                            <option value="">Select Store Name</option>
                            {props.storeList && [...props.storeList]
                                .sort((a, b) => (a.name || '').localeCompare(b.name || ''))
                                .map((store) => (
                                    <option key={store.id} value={store.id}>
                                        {store.name}
                                    </option>
                            ))}
                        </select>
                        {errors.selectedStore && <div className="text-danger">{errors.selectedStore}</div>}
                    </Col>

                    <Col md={6} className='mt-3'>
                        <label><h6><b>Brand : </b></h6></label>
                        <select
                            className="form-control create-new-project-width"
                            onChange={handleBrandChange}
                            value={selectedBrand}
                        >
                            <option value="">Select Brand</option>
                            {selectedStore &&
                                <>
                                    {props.brandList && props.brandList.filter(brand =>
                                        !selectedStore || brand.integerId === parseInt(selectedStore)
                                    ).map((brand) => (
                                        <option key={brand.id} value={brand.id}>
                                            {brand.brandName}
                                        </option>
                                    ))}
                                </>}
                        </select>
                    </Col>
                </Row>

                <Row>
                    <Col md={6}>
                        <div className='mt-3'>
                            <label><h6><b>WorkFlows : <span style={{ color: 'red' }}>*</span></b></h6></label>
                            <Dropdown isOpen={workflowDropdownOpen} toggle={toggleWorkflowDropdown} className="create-new-project-width">
                                <DropdownToggle
                                    caret
                                    className="form-control d-flex justify-content-between align-items-center"
                                    style={{ backgroundColor: 'white', color: '#495057', textAlign: 'left', overflow: 'hidden', textOverflow: 'ellipsis' }}
                                >
                                    <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: '90%' }}>
                                        {getSelectedWorkflowNames()}
                                    </span>
                                </DropdownToggle>
                                <DropdownMenu
                                    style={{ width: '100%', maxHeight: '200px', overflowY: 'auto', padding: '10px' }}
                                >
                                    {props.workFlowList && props.workFlowList.map((workFlow) => (
                                        <FormGroup check key={workFlow.id} className="m-2">
                                            <Label check style={{ cursor: 'pointer', width: '100%' }}>
                                                <Input
                                                    type="checkbox"
                                                    checked={selectedWorkFlow.includes(workFlow.id) || selectedWorkFlow.includes(workFlow.id.toString())}
                                                    onChange={() => handleWorkFlowCheckboxChange(workFlow.id)}
                                                />
                                                {workFlow.name}
                                            </Label>
                                        </FormGroup>
                                    ))}
                                </DropdownMenu>
                            </Dropdown>
                            {errors.selectedWorkFlow && <div className="text-danger">{errors.selectedWorkFlow}</div>}
                        </div>

                        <div className='mt-3'>
                            <label><h6><b>Project Owner : <span style={{ color: 'red' }}>*</span></b></h6></label>
                            <select
                                className="form-control create-new-project-width"
                                onChange={handleProjectOwnerChange}
                                value={selectedProjectOwner}
                            >
                                <option value="">Select Project Owner</option>
                                {props.ownerList && props.ownerList.map((owner) => (
                                    <option key={owner.employeeId} value={owner.employeeId}>
                                        {owner.employeeName}
                                    </option>
                                ))}
                            </select>
                            {errors.selectedProjectOwner && <div className="text-danger">{errors.selectedProjectOwner}</div>}
                        </div>
                    </Col>

                    <Col md={6}>
                        <div className="mt-3">
                            <div className="d-flex align-items-center mb-2">
                                <h6 className="mb-0 mr-3"><b>ASIN List :</b></h6>
                                {!hideAddAsinsButton && (
                                    <Button
                                        className="btn-background-color d-flex align-items-center justify-content-center p-1"
                                        onClick={() => { handleSelectProduct() }}
                                        disabled={!selectedStore}
                                        style={{ minWidth: '40px' }}
                                    >
                                        <img src={NewTaskIcon} style={{ height: '18px' }} alt="add" />
                                    </Button>
                                )}
                                {hideAddAsinsButton && <h6 className="mb-0 ml-2">Not Required</h6>}
                            </div>

                            {!hideAddAsinsButton && (
                              <div
                                  style={{
                                      maxHeight: '120px', 
                                      overflowY: 'auto',
                                      display: 'grid',    
                                      gridTemplateColumns: '1fr 1fr 1fr', 
                                      columnGap: '10px',  
                                      paddingRight: '5px' 
                                  }}
                              >
                                  {Array.isArray(asinList)
                                      ? asinList
                                          .filter(Boolean)
                                          .map((asin, index, filteredArray) => {
                                              const product = productList && productList.find(p => p.asin === asin);
                                              return (
                                                  <div
                                                      key={index}
                                                      title={(product && product.productTitle) || (product && product.name) || ''}
                                                      className="mb-1"
                                                  >
                                                      {asin}{index < filteredArray.length - 1 ? ',' : ''}
                                                  </div>
                                              );
                                          })
                                      : ''}
                              </div>
                          )}
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col md={6} className='mt-3'>
                        <label><h6><b>Graphic Designer : </b></h6></label>
                        <Dropdown isOpen={designerDropdownOpen} toggle={toggleDesignerDropdown} className="create-new-project-width">
                            <DropdownToggle
                                caret
                                className="form-control d-flex justify-content-between align-items-center"
                                style={{ backgroundColor: 'white', color: '#495057', textAlign: 'left', overflow: 'hidden', textOverflow: 'ellipsis' }}
                            >
                                <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: '90%' }}>
                                    {getSelectedDesignerNames()}
                                </span>
                            </DropdownToggle>
                            <DropdownMenu
                                style={{ width: '100%', maxHeight: '200px', overflowY: 'auto', padding: '10px' }}
                            >
                                {props.graphicDesignerList && props.graphicDesignerList.map((designer) => (
                                    <FormGroup check key={designer.id} className="m-2">
                                        <Label check style={{ cursor: 'pointer', width: '100%' }}>
                                            <Input
                                                type="checkbox"
                                                checked={(selectedGraphicDesigner || []).map(Number).includes(Number(designer.id))}
                                                onChange={() => handleGraphicDesignerCheckboxChange(designer.id)}
                                            />
                                            {' '}{designer.name}
                                        </Label>
                                    </FormGroup>
                                ))}
                            </DropdownMenu>
                        </Dropdown>
                    </Col>

                    <Col md={6}>
                        <Row>
                            <Col md={6} className='mt-3'>
                                <label><h6><b>Start Date : </b></h6></label>
                                <div className="position-relative picker-date-width">
                                    <DatePicker
                                        selected={startDate}
                                        onChange={handleStartDateChange}
                                        placeholderText="Select"
                                        className="form-control"
                                        dateFormat="MM/dd/yyyy"
                                    />
                                    <div className="calendar-icon-wrapper">
                                        <FaCalendarAlt className="calendar-icon" />
                                    </div>
                                </div>
                            </Col>

                            <Col md={6} className='mt-3'>
                                <label><h6><b>Due Date : </b></h6></label>
                                <div className="position-relative picker-date-width" >
                                    <DatePicker
                                        selected={dueDate}
                                        onChange={handleDueDateChange}
                                        placeholderText="Select"
                                        className="form-control"
                                        dateFormat="MM/dd/yyyy"
                                        filterDate={(date) => startDate ? date >= startDate : true}
                                    />
                                    <div className="calendar-icon-wrapper">
                                        <FaCalendarAlt className="calendar-icon" />
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row>
                <Col md={12} className='mt-3'>
                <label><h6><b>Note : </b></h6></label>
                <ReactQuill
                          theme={'snow'}
                          modules={Editor.modules}
                          formats={Editor.formats}
                          value={text}
                          onChange={handleQuillChange}
                          bounds={'.quill-prod'}
                          placeholder='Add Your Comments Here' />
                </Col>
                <Col md={12} className='mt-5 d-flex justify-content-center'> <Button 
                className='btn-background-color'
                onClick={handleSaveProjectDetails}
                disabled={loading}
                >
                  {loading ? 'Submitting...' : 'Submit'}
                </Button>
                </Col>
                </Row>
            </Col>
            <CustomModal
                header={'Duplicate Project Warning'}
                isOpen={showConfirmationPopup}
                toggle={() => setShowConfirmationPopup(!showConfirmationPopup)}
                size={"md"}
                className="curve-popup"
             
            >
                <div className="modal-body">
                <p>One or more projects with the same Store, Brand, and Workflow combination already exist:</p>
                {duplicateProjects && duplicateProjects.length > 0 && (
                    <div className="mb-3">
                            <strong>Existing Projects:</strong>
                    <ul className="mt-2">
                        {duplicateProjects.map((proj, index) => (
                            <li key={index}>
                                Project ID: {proj.projectId} | Name: {proj.projectName}
                            </li>
                        ))}
                    </ul>
                    </div>
                )}
                <p className="mb-2">Do you want to create another one?</p>
                <div className='mb-2 d-flex justify-content-end mr-2'>
                                    <Button className=" no-btn-background-color"  onClick={() => handleConfirmationNo()} 
                                        >
                                        No
                                    </Button>   &nbsp;
                                    <Button
                                    //    color="primary"
                                     className='btn-background-color'
                                        onClick={() => handleConfirmationYes()} 
                                        style={{ marginLeft: "10px" }}
                                       >
                                        Yes
                                    </Button>
                                </div>
                                </div>
            </CustomModal>
            <CustomModal
          header={
            <span>
              Add ASINs for : <b>{ selectedStoreName || ''}</b>
            </span>
          }
        isOpen={addProductsPopup}
        toggle={() => {
            setAddProductsPopup(!addProductsPopup);setAsinList([''])
        //   setEmailRecipient('')
        //   // setSelectedStore({ integerId: '' });
        //   setSelectedStoreData({ integerId: '', storeName: '' });
        }}
        size={"xl"}
       className='my-task-custom-module'
      >
        <NewProjectProductList
        setAddProductsPopup={setAddProductsPopup}
        asinList={asinList}
        setAsinList={setAsinList}
        setSelectedAsin={setSelectedAsin}
        productList={productList}
        />
      
      </CustomModal>
        </>
    );
}
const mapStateToProps = state => {
  return {
    token: state.loggedUser.token,
    accessLevel: state.loggedUser.accessLevel,
    status: state.loggedUser.status,
  }
}

export default connect(mapStateToProps)(CreateNewProjectDetails);
